import { FormikTextarea } from "../FormikFields/FormikTextarea.js";
import { FormikFilesPicker } from "../../modules/Files/shared/FormikFilesPicker.js";
import "react";
import { FormLayout, Modal } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { Formik } from "formik";
//#region src/components/Comments/CommentFormModal.tsx
var initialValuesDefault = {
	body: "",
	fileUrls: []
};
var CommentFormModal = ({ commentId, initialValues, onCancel, onSubmit }) => {
	return /* @__PURE__ */ jsx(Modal, {
		closeHandler: onCancel,
		header: commentId ? "Edit Comment" : "New Comment",
		children: /* @__PURE__ */ jsx(Formik, {
			initialValues: {
				...initialValuesDefault,
				...initialValues
			},
			onSubmit: async (values, actions) => {
				await onSubmit(values);
				actions.resetForm();
			},
			children: ({ isSubmitting, submitForm, values }) => /* @__PURE__ */ jsxs(FormLayout, {
				dividers: "space",
				space: "xxs",
				loading: isSubmitting,
				children: [
					/* @__PURE__ */ jsx(FormikTextarea, {
						name: "body",
						value: values.body
					}),
					/* @__PURE__ */ jsx("div", {
						className: "bg-surface-subtle p-xxl text-color-subtle rounded text-center italic",
						children: /* @__PURE__ */ jsx(FormikFilesPicker, {
							name: "fileUrls",
							multi: true
						})
					}),
					/* @__PURE__ */ jsx(FormLayout.Controls, {
						onCancel,
						onSubmit: submitForm,
						submitLabel: commentId ? "Edit" : "Comment"
					})
				]
			})
		})
	});
};
//#endregion
export { CommentFormModal };

//# sourceMappingURL=CommentFormModal.js.map